/**
 * Authentication handler for comments section
 * Manages authentication state and related events
 * 
 * @package PocketOption
 */

import { handleAuthentication } from '../components/auth.js';
import { updateAuthenticatedUI, updateUnauthenticatedUI } from './AuthUI.js';

/**
 * Initialize authentication for the comments section
 */
const initAuthentication = async () => {
  return await handleAuthentication(
    // Authenticated user handler
    (userData) => {
      updateAuthenticatedUI(userData);
    },
    
    // Unauthenticated user handler
    () => {
      updateUnauthenticatedUI();
    },
    
    // Error handler
    (error) => {
      console.error('Error during authentication:', error);
    }
  );
};

export { initAuthentication };
